import { Injectable } from '@angular/core';
import {fromJS} from 'immutable';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserAccess} from '../models/user-access.model';
import { Role } from '../models/role.model';
import { Membership } from '../models/membership.model';
import { DefaultPermissions } from '../../../../shared/components/permissions/models/defaultPermissions.model';
import { GeneralSetting } from '../models/general-setting.model';
import { Language } from '../../../../shared/models/language.enum';
import { RegisterRequirements, UsersSetting } from '../models/users-setting.model';
import { UserSetting } from '../models/userSetting.model';
import {UserGroup} from '../models/user-group.model';
import {SubmitType} from '../../../../shared/models/submit.type';
import {Workspace} from '../../../../shared/models/work-space.model';
import {User} from '../models/user.model';
import {skip, tap} from 'rxjs/operators';
import {UserModel} from '../../../../shared/models/user.model';
import {UserInfo} from '../models/userInfo.model';
import {PasswordErrorType} from '../models/password-error.type';
import {UserFilter} from '../../../../shared/models/user-filter.model';
import {UserFilterRecipientType} from '../../../../shared/models/userOrGroup.model';
import { UsersMetaData } from '../models/users-meta-data.model';
import {ConnectionTestResponse} from '../models/connection-test-response.model';
import {Connection} from '../models/Connection.model';
import {ConnectionForm} from '../../../../shared/models/connection-form.model';
import { AssetsMetaData } from '../../asset/models/assets-meta-data.model';
import { UserDashboardModel } from '../models/userDashboardList.model';

@Injectable()
export class ManagementState {
  workspaceId: string;
  userOrGroupId: string;
  userFilterRecipientType: UserFilterRecipientType;

  private userMinInfo$ = new BehaviorSubject<any>(null);
  private activeWorkspace$ = new BehaviorSubject<Partial<Workspace>>(null);
  private tempUser: any;

  private generalSetting$ = new BehaviorSubject<GeneralSetting>(null);
  private previousGeneralSetting: GeneralSetting;

  private usersSetting$ = new BehaviorSubject<UsersSetting>(null);
  private previousUsersSetting: UsersSetting;

  private userSetting$ = new BehaviorSubject<UserSetting>(null);
  private userDashboardList$ = new BehaviorSubject<UserDashboardModel[]>(null);
  private ipAccessList$ = new BehaviorSubject<string[]>(null);
  private previousUserSetting: UserSetting;
  private registerRequirements$ = new BehaviorSubject<RegisterRequirements[]>(null);

  private defaultRelationsSetting$ = new BehaviorSubject<any>(null);
  private relationsSetting$ = new BehaviorSubject<any>(null);
  private tempRelationsSetting: any;

  private rolesSetting$ = new BehaviorSubject<Role[]>(null);

  private roles$ = new BehaviorSubject<any>(null);
  private tempRoles: any;


  private workSpaces$ = new BehaviorSubject<Partial<Workspace>[]>(null);
  private allWorkSpaces$ = new BehaviorSubject<Partial<Workspace>[]>(null);
  private workspacesWithCreateDashboardGroupPermission$ = new BehaviorSubject<Partial<Workspace>[]>(null);
  private allWorkspacesWithCreateDashboardGroupPermission$ = new BehaviorSubject<Partial<Workspace>[]>(null);
  private selectWorkspaceImage$ = new BehaviorSubject<string>(null);
  private tempWorkSpaces: any;

  private usersWorkSpace$ = new BehaviorSubject<Partial<User>[]>(null);

  private userGroupsWithUserStatus$ = new BehaviorSubject<Partial<UserGroup>[]>(null);
  private tempUserGroupsWithUserStatus: Partial<UserGroup>[];

  private userGroups$ = new BehaviorSubject<UserGroup[]>(null);
  private userGroupsTotalPages$ = new BehaviorSubject<number>(1);
  private userGroupsPageNumber$ = new BehaviorSubject<number>(1);
  private usersNotInUserGroup$ = new BehaviorSubject<Partial<User>[]>(null);
  private addUsersPageNumber$ = new BehaviorSubject<number>(1);
  private addUsersTotalPages$ = new BehaviorSubject<number>(1);

  private userSelect$ = new BehaviorSubject<UserInfo>(null);
  private userGroupSelected$ = new BehaviorSubject<UserGroup>(null);
  private userAllAccess$ = new BehaviorSubject<Partial<UserAccess>[]>(null);
  private selectedAccess$ = new BehaviorSubject<Partial<UserAccess>>(null);
  private groupAssets$ = new BehaviorSubject<any>(null);
  private tempUserSelect: any;
  private tempGroupAssets: any;
  private tempSelectedAccess: Partial<UserAccess>;

  private usersInUserGroupSelected$ = new BehaviorSubject<Partial<User>[]>(null);
  private userGroupAllAccess$ = new BehaviorSubject<Partial<UserAccess>[]>(null);

  private selectedWorkSpace$ = new BehaviorSubject<any>(null);

  private userFilters$ = new BehaviorSubject<Partial<UserFilter>[]>([]);

  private defaultRoles$ = new BehaviorSubject<any>(null);
  private userWorkspaceMemberships$ = new BehaviorSubject<Membership[]>(null);
  private totalPages$ = new BehaviorSubject<number>(1);
  private pageNumber$ = new BehaviorSubject<number>(1);
  private userTotalPages$ = new BehaviorSubject<number>(1);
  private userPageNumber$ = new BehaviorSubject<number>(1);
  private accessTotalPages$ = new BehaviorSubject<number>(1);
  private accessPageNumber$ = new BehaviorSubject<number>(1);
  private userFilterTotalPages$ = new BehaviorSubject<number>(1);
  private userFilterPageNumber$ = new BehaviorSubject<number>(1);

  private passwordError$ = new BehaviorSubject<PasswordErrorType>('NoErrorSubmit');
  private submitState$ = new BehaviorSubject<SubmitType>('notSubmitted');
  private tablePageSize = 9;
  private loadingData$ = new BehaviorSubject<boolean>(false);

  private temporaryPhoneNumber$ = new BehaviorSubject<{value: string;showValue: string; referenceId: string}>(null);
  private confirmationOTP$ = new BehaviorSubject<boolean>(null);

  private usersMetaData$ = new BehaviorSubject<UsersMetaData>(null);
  private userAssetsMetaData$ = new BehaviorSubject<AssetsMetaData>(null);

  private connections$ = new BehaviorSubject<Partial<Connection>[]>([]);
  private connection$ = new BehaviorSubject<Partial<Connection>>(null);
  private connectionTestResponse$ =  new BehaviorSubject<ConnectionTestResponse>(null);
  private workspacesListForConnection$ = new BehaviorSubject<Partial<Workspace>[]>([]);
  private previousConnections: Partial<Connection>[];
  private customFieldsSubject = new BehaviorSubject<any[]>([]);
  private customFields: any[] = [];

  // update BehaviorSubject
  setLoadingData(loading: boolean): void {
    this.loadingData$.next(loading);
  }

  getLoadingData$(): Observable<boolean> {
    return this.loadingData$.asObservable();
  }
  setUserMinInfo(user: UserModel): void {
    this.tempUser = this.userMinInfo$?.getValue();
    this.userMinInfo$.next(user);
  }

  getUserMinInfo$(): Observable<UserModel> {
    return this.userMinInfo$.asObservable();
  }

  setActiveWorkspace(workspace: Partial<Workspace>) {
    if(workspace) {
      this.workspaceId = workspace.workspaceId;
    }
    this.activeWorkspace$.next(workspace);
  }

  getActiveWorkspace$(): Observable<Partial<Workspace>> {
    return this.activeWorkspace$.asObservable();
  }

  updateUserSelect(user): void {
    this.tempUserSelect = this.userSelect$?.value;
    this.userSelect$.next(user);
  }

  cancelUpdateUsersSetting(): void {
    this.usersSetting$.next({...this.usersSetting$.getValue()});
  }

  updateUserGroupSelected(userGroup: UserGroup): void {
    this.userGroupSelected$.next(userGroup);
  }

  updateUserGroupSelectedDetails(numberOfUsers: number,addUsers: boolean): void {
    const newUserGroupSelected = {...this.userGroupSelected$.getValue()};
    const userCount = newUserGroupSelected.userCount;
    if(!addUsers) {
      newUserGroupSelected.userCount = userCount - numberOfUsers;
    } else {
      newUserGroupSelected.userCount = userCount + numberOfUsers;
    }
    newUserGroupSelected.lastModifiedTickTime = new Date().getTime()* 10000 + 621355968000000000;
    this.updateUserGroupSelected(newUserGroupSelected);
  }

  updateUserAllAccess(allAccess): void {
    if(allAccess?.length > 0) {
      allAccess.forEach(access => {
        switch(access.assetsType) {
          case 'Dashboard':
            access.link = `/dashboard/view/${access.workspaceId}/${access.assetId}`;
            break;
          case 'DataSource':
            access.link = `/datasource/${access.workspaceId}/${access.assetId}`;
            break;
          case 'DashboardGroup':
            access.link = `/home/dashboardGroup/${access.workspaceId}/${access.assetId}`;
        }
      });
    }
    this.userAllAccess$.next(allAccess);
  }

  updateGeneralSetting(generalSetting: GeneralSetting): void {
    if(generalSetting.language === 'Persian'){
      generalSetting.language = Language.Persian;
    } else if (generalSetting.language === 'English'){
      generalSetting.language = Language.English;
    }
    if(generalSetting !== null) {
      this.previousGeneralSetting = fromJS(generalSetting).toJS() as unknown as GeneralSetting;
    }
    this.generalSetting$.next(generalSetting);
  }

  updateGeneralSettingIconPath(generalSetting: GeneralSetting): void {
    if(generalSetting.language === 'Persian'){
      generalSetting.language = Language.Persian;
    } else if (generalSetting.language === 'English'){
      generalSetting.language = Language.English;
    }
    this.generalSetting$.next(generalSetting);
  }

  updateUsersSetting(userSetting: UsersSetting) {
    if (userSetting !== null) {
      const tempUsersSetting = { ...userSetting };
      this.previousUsersSetting = {...this.usersSetting$.getValue()};
      this.usersSetting$.next(tempUsersSetting);
    } else {
      this.usersSetting$.next(null);
    }
  }

  setUsersSetting(usersSetting: any) {
    usersSetting.loginIds = usersSetting.loginIds.split(', ');
    this.updateUsersSetting(usersSetting);
  }

  setRegisterRequirements(requirements: RegisterRequirements[]): void {
    this.registerRequirements$.next(requirements);
  }

  updateUserSetting(userSetting: UserSetting): void {
    this.previousUserSetting = {...userSetting};
    this.userSetting$.next(userSetting);
  }

  updateUserDashboardList(dashboardList: UserDashboardModel[]): void {
    this.userDashboardList$.next(dashboardList);
  }

  updateIPAccessList(ipAccessList: string[]): void {
    this.ipAccessList$.next(ipAccessList);
  }

  updateRolesSetting(roles: any) {
    this.addExtraInfoRoles(roles);
    this.rolesSetting$.next(roles);
  }

  updateRoleSetting(role: any): void {
    const currRoles = this.rolesSetting$?.value;
    const foundIndex = currRoles.findIndex(temp => role.id === temp.id);
    currRoles[foundIndex] = role;
  }

  updateDefaultRelationsSetting(relationsSetting: any): void {
    this.defaultRelationsSetting$.next(relationsSetting);
  }

  updateRelationsSetting(relationsSetting: any): void {
    this.tempRelationsSetting = this.relationsSetting$?.value;
    this.relationsSetting$.next(relationsSetting);
  }

  updateRoles(roles: any): void {
    this.tempRoles = this.roles$.value;
    this.roles$.next(roles);
  }

  updateDeletedRoles(deleteRoles: any): void {
    const currRoles = this.rolesSetting$.value;
    const filterRoles = [];
    currRoles.forEach(role => {
      let roleNotExist = true;
      deleteRoles.forEach(deleteRole => {
        if (role.id === deleteRole.id) {
          roleNotExist = false;
        }
      });
      if (roleNotExist) {
        filterRoles.push(role);
      }
    });
    this.rolesSetting$.next(filterRoles);
  }

  addRole(role: any): void {
    const currRoles = this.rolesSetting$.value;
    const roles = [role];
    this.addExtraInfoRoles(roles);
    currRoles.push(roles[0]);
    this.rolesSetting$.next(currRoles);
  }

  updateWorkSpaces(workSpaces): void {
    this.tempWorkSpaces = this.workSpaces$?.value;
    this.workSpaces$.next(workSpaces);
  }

  updateAllWorkSpaces(workSpaces): void {
    this.allWorkSpaces$.next(workSpaces);
  }

  updateWorkspacesWithCreateDashboardGroupPermission(workspaces: any): void {
    this.allWorkspacesWithCreateDashboardGroupPermission$.next(workspaces);
  }

  updateWorkSpace(workspace: any): void {
    const currWorkspaces = [...this.workSpaces$.value];
    const foundIndex = currWorkspaces.findIndex(temp => temp.workspaceId === workspace.workspaceId);
    currWorkspaces[foundIndex] = workspace;
    this.updateWorkSpaces(currWorkspaces);
  }

  addWorkSpace(workspace: any): void {
    const roles = [...this.rolesSetting$?.value];
    const currWorkspaces = [...this.workSpaces$?.value];
    const updateWorkspace = this.addExtraInfoWorkSpaces([workspace],roles);
    currWorkspaces.push(updateWorkspace[0]);
    this.updateWorkSpaces(currWorkspaces);
  }

  updateUsersWorkSpace(users: Partial<User>[]): void {
    this.usersWorkSpace$.next(users);
  }

  updateUserWorkSpace(item: Partial<User>): void {
    const updateUsers = [...this.usersWorkSpace$?.value];
    const foundIndex = updateUsers.findIndex(user => user.userId === item.userId);
    updateUsers[foundIndex] = item;
    this.updateUsersWorkSpace(updateUsers);
  }
  updateUserGroupsWithUserStatus(userGroups: Partial<UserGroup>[]): void {
    if(this.userGroupsWithUserStatus$?.value !== null) {
      this.tempUserGroupsWithUserStatus = [...this.userGroupsWithUserStatus$?.getValue()];
    }
    this.userGroupsWithUserStatus$.next(userGroups);
  }

  addStatusUserToUserGroup(userGroupId: string): void {
    const userGroups = [...this.userGroupsWithUserStatus$?.getValue()];
    const foundIndex = userGroups.findIndex(userGroup => userGroup.userGroupId === userGroupId);
    if(foundIndex > -1) {
      userGroups[foundIndex].isMember = true;
      this.updateUserGroupsWithUserStatus(userGroups);
    }
  }

  removeStatusUserFromUserGroup(userGroupId: string): void {
    const userGroups = [...this.userGroupsWithUserStatus$?.getValue()];
    const foundIndex = userGroups.findIndex(userGroup => userGroup.userGroupId === userGroupId);
    if(foundIndex > -1) {
      userGroups[foundIndex].isMember = false;
      this.updateUserGroupsWithUserStatus(userGroups);
    }
  }

  updateUserGroups(userGroups: UserGroup[]): void {
    if(userGroups) {
      userGroups.forEach(userGroup =>
        userGroup.link = `/home/user-managment/group/${userGroup.workspaceId}/${userGroup.userGroupId}`);
    }
    this.userGroups$.next(userGroups);
  }

  updateUserGroupsTotalPages(totalPages: number): void {
    this.userGroupsTotalPages$.next(totalPages);
  }

  getUserGroupsTotalPages$(): Observable<number> {
    return this.userGroupsTotalPages$.asObservable();
  }

  updateUserGroupsPageNumber(pageNumber: number): void {
    this.userGroupsPageNumber$.next(pageNumber);
  }

  getUserGroupsPageNumber$(): Observable<number> {
    return this.userGroupsPageNumber$.asObservable();
  }

  updateSelectedWorkSpace(workSpace: any): void {
    this.selectedWorkSpace$.next(workSpace);
  }

  addGroup(userGroup: UserGroup) {
    const updateGroups = [...this.userGroups$.getValue()];
    updateGroups.push(userGroup);
    this.updateUserGroups(updateGroups);
  }

  updateUsersOfUserGroupSelected(users: Partial<User>[]): void {
    this.usersInUserGroupSelected$.next(users);
  }

  updateUserGroupAllAccess(allAccess: Partial<UserAccess>[]): void {
    this.userGroupAllAccess$.next(allAccess);
  }

  updateAccessTotalPages(totalPages: number): void {
    this.accessTotalPages$.next(totalPages);
  }

  getAccessTotalPages$(): Observable<number> {
    return this.accessTotalPages$.asObservable();
  }

  updateAccessPageNumber(pageNumber: number) {
    this.accessPageNumber$.next(pageNumber);
  }

  getAccessPageNumber$(): Observable<number> {
    return this.accessPageNumber$.asObservable();
  }

  updateUsersNotInUserGroup(users: Partial<User>[]): void {
    this.usersNotInUserGroup$.next(users);
  }

  getUsersNotInUserGroup$(): Observable<Partial<User>[]> {
    return this.usersNotInUserGroup$.asObservable().pipe(skip(1));
  }

  updateAddUsersPageNumber(pageNumber: number): void {
    this.addUsersPageNumber$.next(pageNumber);
  }

  getAddUsersPageNumber$(): Observable<number> {
    return this.addUsersPageNumber$.asObservable().pipe(skip(1));
  }

  updateAddUsersTotalPages(totalPages: number): void {
    this.addUsersTotalPages$.next(totalPages);
  }

  getAddUsersTotalPages$(): Observable<number> {
    return this.addUsersTotalPages$.asObservable().pipe(skip(1));
  }

  addUsersToSelectedUserGroup(users: Partial<User>[]): void {
    const updateGroupUsers = [...this.usersInUserGroupSelected$.getValue()];
    let totalPages = this.totalPages$.getValue();
    totalPages = totalPages === 0 ? 1: totalPages;
    const usersLength = users.length;
    let groupUsersLength = updateGroupUsers.length;
    this.updateTotalPages(Math.floor(Math.abs(usersLength+groupUsersLength) / this.tablePageSize) + totalPages);
    if(groupUsersLength < this.tablePageSize) {
      users.forEach(user => {
        if(groupUsersLength < this.tablePageSize) {
          updateGroupUsers.push(user);
          groupUsersLength = updateGroupUsers.length;
        }
      });
      this.updateUsersOfUserGroupSelected(updateGroupUsers);
    }
  }

  updateWorkspaceRoles(roles: any, type: string): void {
    const tempRoles = [];
    if(type === 'DashboardGroup') {
      roles.forEach(role => {
        const tempRole = { ...role };
        tempRole.permissions = this.filterData('DashboardOfGroup', role.permissions);
        tempRoles.push(tempRole);
      });
      roles.forEach(role => role.permissions = this.filterData(type, role.permissions));
      this.defaultRoles$.next([roles, tempRoles]);
    } else {
      roles.forEach(role => role.permissions = this.filterData(type, role.permissions));
      this.defaultRoles$.next(roles);
    }
  }

  updateUserWorkSpaceMemberships(memberships: Membership[]): void {
    this.userWorkspaceMemberships$.next(memberships);
  }

  updateUserAccess(access: Partial<UserAccess>): void{
    const updateUserAllAccess = [...this.userAllAccess$.getValue()];
    const foundedIndex = updateUserAllAccess.findIndex(userAccess => userAccess.accessId === access.accessId);
    if(foundedIndex > -1) {
      updateUserAllAccess[foundedIndex] = access;
      this.updateUserAllAccess(updateUserAllAccess);
    }
  }

  updateUserGroupAccess(access: Partial<UserAccess>) {
    const updateUserGroupAllAccess = [...this.userGroupAllAccess$.getValue()];
    const foundedIndex = updateUserGroupAllAccess.findIndex(userGroupAccess => userGroupAccess.accessId === access.accessId);
    if(foundedIndex > -1) {
      updateUserGroupAllAccess[foundedIndex] = access;
    }
    this.updateUserGroupAllAccess(updateUserGroupAllAccess);
  }

  updateSelectedAccess(access: Partial<UserAccess>): void {
    if(this.selectedAccess$.value !== null && access !== null) {
      this.tempSelectedAccess = {...this.selectedAccess$?.getValue()};
      if(access.assetsType === 'DashboardGroup') {
        this.tempSelectedAccess.permissions.dashboard =
          new Map(JSON.parse(JSON.stringify(Array.from(this.tempSelectedAccess.permissions.dashboard))));
        this.tempSelectedAccess.permissions.dashboardGroup =
          new Map(JSON.parse(JSON.stringify(Array.from(this.tempSelectedAccess.permissions.dashboardGroup))));
        this.tempSelectedAccess.permissionsBlocked.dashboard =
          new Map(JSON.parse(JSON.stringify(Array.from(this.tempSelectedAccess.permissionsBlocked.dashboard))));
        this.tempSelectedAccess.permissionsBlocked.dashboardGroup =
          new Map(JSON.parse(JSON.stringify(Array.from(this.tempSelectedAccess.permissionsBlocked.dashboardGroup))));
      } else {
        this.tempSelectedAccess.permissions =
          new Map(JSON.parse(JSON.stringify(Array.from(this.tempSelectedAccess.permissions))));
        this.tempSelectedAccess.permissionsBlocked =
          new Map(JSON.parse(JSON.stringify(Array.from(this.tempSelectedAccess.permissionsBlocked))));
      }
    }
    this.selectedAccess$.next(access);
  }

  updateUserFilters(userFilters: Partial<UserFilter>[]): void {
    this.userFilters$.next(userFilters);
  }

  updateTotalPages(totalPages: number): void {
    this.totalPages$.next(totalPages);
  }

  updatePageNumber(pageNumber: number): void {
    this.pageNumber$.next(pageNumber);
  }

  updateUserTotalPages(totalPages: number): void {
    this.userTotalPages$.next(totalPages);
  }

  updateUserPageNumber(pageNumber: number): void {
    this.userPageNumber$.next(pageNumber);
  }

  updateUserFilterTotalPages(totalPages: number): void {
    this.userFilterTotalPages$.next(totalPages);
  }

  updateUserFilterPageNumber(pageNumber: number): void {
    this.userFilterPageNumber$.next(pageNumber);
  }

  // get Observable
  getUser$(): Observable<any> {
    return this.userMinInfo$.asObservable();
  }

  getGeneralSetting$(): Observable<GeneralSetting> {
    return this.generalSetting$.asObservable();
  }

  getRegisterRequirements$(): Observable<RegisterRequirements[]> {
    return this.registerRequirements$.asObservable();
  }

  getUsersSetting$(): Observable<UsersSetting> {
    return this.usersSetting$.asObservable();
  }

  getUserSetting$(): Observable<any> {
    return this.userSetting$.asObservable().pipe(skip(1));
  }

  getUserDashboardList$(): Observable<UserDashboardModel[]> {
    return this.userDashboardList$.asObservable().pipe(skip(1));
  }

  getIPAccessListList$(): Observable<string[]> {
    return this.ipAccessList$.asObservable().pipe(skip(1));
  }

  getDefaultRelationsSetting(): any {
    return this.defaultRelationsSetting$.value;
  }

  getRelationsSetting$(): Observable<any> {
    return this.relationsSetting$.asObservable();
  }

  getRoles$(): Observable<any> {
    return this.roles$.asObservable().pipe(skip(1));
  }

  getRolesSetting$(): Observable<Role[]> {
    return this.rolesSetting$.asObservable();
  }

  getWorkSpaces$(): Observable<Partial<Workspace>[]> {
    return this.workSpaces$.asObservable().pipe(skip(1));
  }

  getAllWorkSpaces$(): Observable<Partial<Workspace>[]> {
    return this.allWorkSpaces$.asObservable();
  }

  getWorkspacesWithCreateDashboardGroupPermission$(): Observable<Partial<Workspace>[]> {
    return this.allWorkspacesWithCreateDashboardGroupPermission$.asObservable();
  }

  getUsersWorkSpace$(): Observable<Partial<User>[]> {
    return this.usersWorkSpace$.asObservable();
  }

  getUserGroupsWithUserStatus$(): Observable<Partial<UserGroup>[]> {
    return this.userGroupsWithUserStatus$.asObservable().pipe(skip(1));
  }

  getUserGroups$(): Observable<any> {
    return this.userGroups$.asObservable();
  }

  getUserSelect$(): Observable<any> {
    return this.userSelect$.asObservable();
  }

  getUserGroupSelected$(): Observable<UserGroup> {
    return this.userGroupSelected$.asObservable();
  }

  getUserAllAccess$(): Observable<Partial<UserAccess>[]> {
    return this.userAllAccess$.asObservable();
  }

  getUsersInUserGroupSelected$(): Observable<Partial<User>[]> {
    return this.usersInUserGroupSelected$.asObservable().pipe(skip(1));
  }

  getUserGroupAllAccess$(): Observable<Partial<UserAccess>[]> {
    return this.userGroupAllAccess$.asObservable();
  }

  getDefaultRoles$(): Observable<any> {
    return this.defaultRoles$.asObservable();
  }

  getUserWorkSpaceMamberships$(): Observable<any> {
    return this.userWorkspaceMemberships$.asObservable();
  }

  getUserFilters$(): Observable<Partial<UserFilter>[]> {
    return this.userFilters$.asObservable();
  }

  getTotalPages$(): Observable<any> {
    return this.totalPages$.asObservable();
  }

  getPageNumber$(): Observable<any> {
    return this.pageNumber$.asObservable();
  }

  setUsersMetaData(metadata: UsersMetaData): void {
    this.usersMetaData$.next(metadata);
  }

  getUsersMetaData$(): Observable<UsersMetaData> {
    return this.usersMetaData$.asObservable();
  }

  setUserAssetsMetaData(metadata: AssetsMetaData): void {
    this.userAssetsMetaData$.next(metadata);
  }

  getUserAssetsMetaData$(): Observable<AssetsMetaData> {
    return this.userAssetsMetaData$.asObservable();
  }

  getSelectedAccess$(): Observable<Partial<UserAccess>> {
    return this.selectedAccess$.asObservable();
  }

  getUserPageNumber$(): Observable<any>  {
    return this.userPageNumber$.asObservable();
  }

  getUserTotalPages$(): Observable<any>  {
    return this.userTotalPages$.asObservable();
  }

  getUserFilterPageNumber$(): Observable<any>  {
    return this.userFilterPageNumber$.asObservable();
  }

  getUserFilterTotalPages$(): Observable<any>  {
    return this.userFilterTotalPages$.asObservable();
  }

  // rollBacks
  rollBackUser() {
    this.userMinInfo$.next(this.tempUser);
    this.tempUser = null;
  }

  rollBackGeneralSetting() {
    this.generalSetting$.next(this.previousGeneralSetting);
  }

  rollBackUsersSetting() {
    this.usersSetting$.next({...this.previousUsersSetting});
  }

  rollBackRelationsSetting() {
    this.relationsSetting$.next(this.tempRelationsSetting);
    this.tempRelationsSetting = null;
  }

  rollBackWorkSpaces() {
    this.workSpaces$.next(this.tempWorkSpaces);
    this.tempWorkSpaces = null;
  }

  rollBackUserGroups() {
    this.userGroupsWithUserStatus$.next(this.tempUserGroupsWithUserStatus);
    this.tempUserGroupsWithUserStatus = null;
  }

  rollBackGroupAssets() {
    this.groupAssets$.next(this.tempGroupAssets);
    this.tempGroupAssets = null;
  }

  rollBackAccess(): void {
    this.selectedAccess$.next(this.tempSelectedAccess);
    this.tempSelectedAccess = null;
  }

  rollBackUserSetting() {
    this.userSetting$.next(this.previousUserSetting);
  }

  // extra logic
  filterWorkSpaces(workspaceId: any) {
    let filteredWorkSpaces = [...this.workSpaces$.value];
    filteredWorkSpaces = filteredWorkSpaces.filter(workspace => workspace.workspaceId !== workspaceId);
    this.updateWorkSpaces(filteredWorkSpaces);
  }

  filterUserGroupsWorkSpace(userGroupId: string): void {
    let updateUserGroups = [...this.userGroups$.value];
    updateUserGroups = updateUserGroups.filter(userGroup => userGroup.userGroupId !== userGroupId);
    this.updateUserGroups(updateUserGroups);
  }

  updateUserGroupName(userGroupId: string, name: string) {
    const updateUserGroups = [...this.userGroups$.value];
    const foundIndex = updateUserGroups.findIndex(userGroup => userGroup.userGroupId === userGroupId);
    updateUserGroups[foundIndex].userGroupName = name;
    this.updateUserGroups(updateUserGroups);
  }

  addExtraInfoWorkSpaces(workspaces: any, roles: any): any {
    const tempWorkSpaces = [...workspaces];
    tempWorkSpaces?.forEach(workspace => {
      workspace.isSelect = false;
      workspace.isChecked = false;
      const tempRoles = [];
      roles?.forEach(role => {
        role.isActive = false;
        role.isChecked = false;
        tempRoles.push({ ...role });
      });
      tempRoles.forEach(role => {
        if (workspace.roles?.includes(role.id)) {
          role.isActive = true;
        }
      });
      workspace.roles = tempRoles;
    });
    return tempWorkSpaces;
  }

  addExtraInfoAccess(allAccess: Partial<UserAccess>[]): Partial<UserAccess>[] {
    const tempAllAccess = fromJS(allAccess).toJS() as unknown as UserAccess[];
    const roles = this.roles$.getValue();
    const userSelect = this.userSelect$.getValue();
    const defaultPermissions = new DefaultPermissions();
    if(roles !== null) {
      tempAllAccess.forEach((access,index) => {
        let permissions = [];
        let permissionsBlocked = [];
        if(access.isRole) {
          for(const role of roles) {
            if (role.id === access.roleId) {
              permissions = role.permissions;
              break;
            }
          }
        } else {
          permissions = access.permissions;
        }
        const highestRoleId = userSelect?.workspacesHighestLevel[access.workspaceId]?.roleId;
        if(highestRoleId && access?.highestRoleName) {
          for(const role of roles) {
            if (role.id === highestRoleId) {
              permissionsBlocked = role.permissions;
              break;
            }
          }
          if(access.assetsType !== 'DashboardGroup') {
            tempAllAccess[index].permissionsBlocked = defaultPermissions.
            mapSpecificPermissions(permissionsBlocked,access.assetsType,true);
          } else {
            tempAllAccess[index].permissionsBlocked = {
              dashboard: defaultPermissions.mapSpecificPermissions(permissionsBlocked, 'Dashboard', true),
              dashboardGroup: defaultPermissions.mapSpecificPermissions(permissionsBlocked, 'DashboardGroup', true),
            };
          }
        } else { // group
          if(access.assetsType !== 'DashboardGroup') {
            tempAllAccess[index].permissionsBlocked = defaultPermissions.filter(access.assetsType);
          } else {
            tempAllAccess[index].permissionsBlocked = {
              dashboard: defaultPermissions.filter('Dashboard'),
              dashboardGroup: defaultPermissions.filter('DashboardGroup'),
            };
          }
        }
        if(tempAllAccess[index].assetsType !== 'DashboardGroup') {
          tempAllAccess[index].permissions = defaultPermissions.
          mapSpecificPermissions(permissions,access.assetsType,false);
        } else {
          tempAllAccess[index].permissions = {
            dashboard: defaultPermissions.mapSpecificPermissions(permissions, 'Dashboard', false),
            dashboardGroup: defaultPermissions.mapSpecificPermissions(permissions, 'DashboardGroup', false),
        };
        }
      });
    }
    return tempAllAccess;
  }

  filterData(type: string, data: any): any {
    let temp;
    switch (type) {
        case 'Dashboard':
            temp = data.filter(x => x >= 200 && x <= 299).sort();
            break;
        case 'DashboardGroup':
            temp = data.filter(x => x >= 100 && x <= 199).sort();
            break;
        case 'DataSource':
            temp = data.filter(x => x >= 400 && x <= 499).sort();
            break;
        case 'DashboardOfGroup':
            temp = data.filter(x => x >= 200 && x <= 299).sort();
            break;
    }
    return temp ? temp : [];
  }

  addExtraInfoMemberships(memberships: any): Membership[] {
    if (this.roles$?.value !== null) {
      const roles: Role[] = [...this.roles$?.value];
      const tempMemberships = [...memberships];
      let result: Membership[] = [...memberships];
      roles.forEach(role => {
        role.isActive = false;
        role.isChecked = false;
      });

      tempMemberships.forEach(workspace => {
        const tempRoles: Role[] = [];
        workspace.workspaceHighestRole = {
          id: workspace.workspaceHighestRole,
          name: '',
          description: '',
          permissions: [],
        };
        workspace.roles.forEach((roleId: string) => {
          workspace.isVisible = false;
          workspace.status = '';
          for (const role of roles) {
            if (role.id === roleId) {
              role.isActive = true;
              tempRoles.push(role);
              if (workspace.workspaceHighestRole.id === roleId) {
                role.isChecked = true;
                workspace.workspaceHighestRole = role;
              } else {

              }
              break;
            }
          }
        });
        workspace.roles = tempRoles;
      });

      result = [...tempMemberships];
      return result;
    }

    return null;
  }

  addExtraInfoRoles(roles: Role[]): void {
    roles.forEach((role: Role) => {
      const permissions = new DefaultPermissions();
      role.permissions = permissions.mapPermissions(role.permissions);
    });
  }

  setSubmitState(submitState: SubmitType): void {
    this.submitState$.next(submitState);
  }

  getSubmitState$(): Observable<SubmitType> {
    return this.submitState$.asObservable();
  }

  setPasswordErrorState(error?: string) {
    if(!error) {
      this.passwordError$.next('NoErrorSubmit');
    } else if(error === 'رمز عبور اشتباه است.') {
      this.passwordError$.next('CurrentPasswordError');
    } else {
      this.passwordError$.next('NoError');
    }
  }

  setSelectWorkspaceImage(filePath: string){
    this.selectWorkspaceImage$.next(filePath);
  }

  getSelectWorkspaceImage$(){
    return this.selectWorkspaceImage$.asObservable();
  }

  getPasswordErrorState$(): Observable<PasswordErrorType> {
    return this.passwordError$.asObservable();
  }

  updateTemporaryPhoneNumber(phoneNumber: string, showNumber: string, referenceId: string): void {
    this.temporaryPhoneNumber$.next({value: phoneNumber, showValue: showNumber, referenceId});
  }

  getTemporaryPhoneNumber$(): Observable<{ value: string; showValue: string; referenceId: string}> {
    return this.temporaryPhoneNumber$.asObservable();
  }

  updateConfirmationOTP(confirmationOTP: boolean): void {
    this.confirmationOTP$.next(confirmationOTP);
  }

  getConfirmationOTP$(): Observable<boolean> {
    return this.confirmationOTP$.asObservable();
  }

  updateConnections(connections: Partial<Connection>[]): void {
      this.connections$.next(connections);
  }

  updateConnection(connectionForm: Partial<ConnectionForm>, connectionId: string): void {
    const updateConnections = this.connections$.getValue();
    const foundedIndex = updateConnections.findIndex(connection => connection.id === connectionId);
    if(foundedIndex > -1) {
      updateConnections[foundedIndex].name = connectionForm.name;
      updateConnections[foundedIndex].serverAddress = connectionForm.serverAddress;
      updateConnections[foundedIndex].portNumber = connectionForm.portNumber;
      updateConnections[foundedIndex].dbName = connectionForm.dbName;
      updateConnections[foundedIndex] = {...updateConnections[foundedIndex]};
      this.connections$.next([...updateConnections]);
    }
  }

  changeConnectionActivationStatus(connectionId: string, isActive: boolean): void {
    const updateConnections = this.connections$.getValue();
    this.previousConnections = [...updateConnections];
    const foundedIndex = updateConnections.findIndex(tempConnection => tempConnection.id === connectionId);
    if(foundedIndex > -1) {
      updateConnections[foundedIndex].isActive = isActive;
      this.connections$.next([...updateConnections]);
    }

  }

  updateConnectionWorkspaces(selectedWorkspaces: string[], connectionId: string): void {
    const updateConnections = this.connections$.getValue();
    const foundedIndex = updateConnections.findIndex(connection => connection.id === connectionId);
    if(foundedIndex > -1) {
      updateConnections[foundedIndex].workspaceNames = [...selectedWorkspaces];
      this.connections$.next([...updateConnections]);
    }
  }

  addConnectionToList(connection: Partial<Connection>) {
    const updateConnections = this.connections$.getValue();
    updateConnections.push(connection);
    this.connections$.next([...updateConnections]);
  }

  deleteConnection(connectionId: string): void {
    const updateConnections = this.connections$.getValue();
    const foundedIndex = updateConnections.findIndex(connection => connection.id === connectionId);
    if(foundedIndex > -1) {
      updateConnections.splice(foundedIndex,1);
      this.connections$.next([...updateConnections]);
    }
  }

  rollBackConnections(): void {
    this.connections$.next(this.previousConnections);
    this.previousConnections = null;
  }

  getConnections$(): Observable<Partial<Connection>[]> {
      return this.connections$.asObservable();
  }

  setConnectionTestResponse(response): void {
    this.connectionTestResponse$.next(response);
  }

  getConnectionTestResponse$(): Observable<ConnectionTestResponse> {
    return this.connectionTestResponse$.asObservable();
  }

  setConnection(connection: Partial<Connection>): void {
    this.connection$.next(connection);
  }

  getConnection$(): Observable<Partial<Connection>> {
    return this.connection$.asObservable().pipe(skip(1));
  }

  updateWorkspacesListForConnection(workspaces: Partial<Workspace>[]): void {
    this.workspacesListForConnection$.next(workspaces);
  }

  getWorkspacesListForConnection$(): Observable<Partial<Workspace>[]> {
    return this.workspacesListForConnection$.asObservable().pipe(skip(1));
  }

  setCustomFields(customFields: any[]): void {
    this.customFields = customFields; 
    this.customFieldsSubject.next(customFields);  
  }

  getCustomFields$(): Observable<any[]> {
    return this.customFieldsSubject.asObservable();  
  }

}
